import {Hint} from './Hint';
import {GroupA} from './GroupA';
import {GroupB} from './GroupB';
import {GroupC} from './GroupC';
import {GroupD} from './GroupD';
import {GroupE} from './GroupE';
import {BoxNode} from './BoxNode';
import {Wrapper} from './Wrapper';
import {Outcome} from './Outcome';
import {EndNode} from './EndNode';
import {ViewWrap} from './ViewWrap';
import {Feedback} from './Feedback';
import {StepNode} from './StepNode';
import {JointNode} from './JointNode';
import {StartNode} from './StartNode';
import {Technique} from './Technique';
import {TitleNode} from './TitleNode';
import {ViewTabPane} from './ViewTabPane';
import {StepOptions} from './StepOptions';
import {ExperimentStep} from './ExperimentStep';
import {StepViewComplete} from './StepViewComplete';
import {TechniqueViewComplete} from './TechniqueViewComplete';
import {TechniqueOption} from './TechniqueOption';
import {StepOptionsModal} from './StepOptionsModal';
import {TechniquesOptionsModal} from './TechniquesOptionModal';
import {ExperimentOutcomesModal} from './ExperimentOutcomesModal';

export const DesignChapter = {
  Hint,
  GroupA,
  GroupB,
  GroupC,
  GroupD,
  GroupE,
  BoxNode,
  Wrapper,
  Outcome,
  EndNode,
  ViewWrap,
  Feedback,
  StepNode,
  JointNode,
  StartNode,
  Technique,
  TitleNode,
  ViewTabPane,
  StepOptions,
  ExperimentStep,
  StepViewComplete,
  TechniqueViewComplete,
  StepOptions,
  TechniqueOption,
  StepOptionsModal,
  TechniquesOptionsModal,
  ExperimentOutcomesModal,
};
